const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';



const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.grid__item', 
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

function wishlistbtn(button, productHandle){
  
    updateWishlist(productHandle);
    button.classList.toggle(BUTTON_ACTIVE_CLASS);
    // setupButtons(document.querySelectorAll(".wishlist-btn"))
}

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    
  });  
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = async (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });

  document.dispatchEvent(event);

  document.querySelectorAll('.wishlist-count-bubble').forEach(container => {
    container.querySelectorAll('span').forEach(span => span.text = wishlist.length);
    if(window.wishlistCount > 1){
      container.style.display = "flex";
    }
  });

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();

  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) {wishlist.push(handle); window.wishlistCount = window.wishlistCount + 1}
  else {wishlist.splice(indexInWishlist, 1); window.wishlistCount = window.wishlistCount - 1}

  document.querySelectorAll('.wishlist-count-bubble').forEach(container => {
    container.querySelectorAll('span').forEach(span => span.textContent = window.wishlistCount); 
    if(window.wishlistCount > 1){
      container.style.display = "block";
    }
  });
  
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

window.wishlistCount = getWishlist().length;

document.querySelectorAll('.wishlist-count-bubble').forEach(container => {
  container.querySelectorAll('span').forEach(span => span.textContent = window.wishlistCount); 
  if(window.wishlistCount > 1){
    container.style.display = "block";
  }
});



//Policy Setup
if(document.querySelector('.shopify-policy__body') && document.querySelector('.shopify-policy__container')){
  
}

// setTimeout(() => {
//     if(location.href.includes('?wishlist=')) {
//         const products = location.href.split('?wishlist=')[1];
//         localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, products);
//         location.href = '/pages/wishlist';
//     }
// }, 1000);


window.onload = function(){
  setupButtons(document.querySelectorAll(".wishlist-btn"))
}
